import { useMemo } from "react"
import { WHOLESALE_SERVICE_NAMES } from "~/shared/kpi"
import { ConnectionStatus } from "../api/types"
import useConnectedServices from "./connected-services"

// The company's CONNECTED retailer sell-through connectors (email ingestion:
// REI, Sam's Club, Whole Foods, Walmart, Target, SPINS, Kroger). They gate the
// 3rd Party Retail Revenue table (slug `wholesale`) on the Revenue KPI page and
// pick its rows, and gate that rollup's row in the Total Business Revenue table.
// An ingestion connector turns CONNECTED on its first accepted upload
// (validated and stored), before the pipeline processes the file.
export function useConnectedWholesaleServices(): string[] {
  const { connectedServices } = useConnectedServices()
  return useMemo(
    () =>
      connectedServices
        ?.filter(
          s =>
            s.status === ConnectionStatus.CONNECTED &&
            WHOLESALE_SERVICE_NAMES.includes(s.serviceName),
        )
        .map(s => s.serviceName) ?? [],
    [connectedServices],
  )
}
